// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var AccountAnalyticsLogo = function AccountAnalyticsLogo(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      opacity: ".5",
      d: "M5 14.5H2.5v-13h8.71l2.29 2.29V7h-1V4.21L10.79 2.5H3.5v11H5v1z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      opacity: ".5",
      d: "M12 4h.29l.21.21V5H9V2.5h1V4"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: "5.5",
      y: "11.5",
      width: "2",
      height: "3",
      rx: ".5"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: "8.5",
      y: "9.5",
      width: "2",
      height: "5",
      rx: ".5"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: "11.5",
      y: "7.5",
      width: "2",
      height: "7",
      rx: ".5"
    }))
  );
};

export default AccountAnalyticsLogo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/AccountAnalyticsLogo.js
// module id = 979
// module chunks = 0